import request from '@/utils/http'

export function login(data) {
  return request({
    url: '/h5/login',
    method: 'post',
    data
  })
}

export function getUserInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}
